import React, { useState } from 'react';
import Modal from '@/components/ui/Modal';
import AddOneTimerForm from './AddOneTimerForm';
import Button from '@/components/ui/Button';

const AddOneTimerModal: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <>
      {/* Desktop Button */}
      <div className="hidden md:flex justify-end mb-6">
        <Button onClick={openModal} size="lg" className={isOpen ? 'ring-2 ring-primary' : ''}>
          <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
          </svg>
          Add New Task
        </Button>
      </div>

      {/* Mobile FAB */}
      <button
        onClick={openModal}
        aria-label="Add new task"
        className={`md:hidden fixed bottom-6 right-6 bg-green-600 hover:bg-green-700 text-white p-4 rounded-full shadow-lg focus:outline-none focus:ring-2 focus:ring-green-500 transition-transform ${isOpen ? 'scale-90 opacity-80' : 'hover:scale-110'}`}
      >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
        </svg>
      </button>

      <Modal isOpen={isOpen} onClose={closeModal} title="Add One-Time Task" maxWidth="md" bottomSheetMobile>
        <AddOneTimerForm onSuccess={closeModal} />
      </Modal>
    </>
  );
};

export default AddOneTimerModal; 